import { createSelector } from "reselect";

export const shouldDisplayHiddenSites = createSelector(
  (state) => state.generalSettings?.includeHiddenSites,
  (includeHiddenSites) => includeHiddenSites || false,
);
